import { atLeast, type OperatorRole } from '@lib/operator';

import { useOperator } from './use-operator';

/**
 * The signed-in operator's tier, for deciding what to *render*.
 *
 * Falls back to `read-only` while the session query is in flight or has failed,
 * which is the same fail-closed default the API applies to an unlisted
 * employee. The cost of guessing low is a button that appears a moment late;
 * the cost of guessing high is a button that 403s, which teaches operators that
 * the app is broken.
 */
export function useOperatorRole(): OperatorRole {
    return useOperator().data?.role ?? 'read-only';
}

/**
 * May the operator reach a route gated at `minimum`?
 *
 * **This hides affordances; it does not protect anything.** The API's
 * `RolesGuard` is the boundary, and it re-checks every call regardless of what
 * this bundle believes. What this buys is that nobody clicks a control that was
 * always going to be refused — the tiers here must therefore match the
 * `@RequiresRole()` on the route the control calls, or the UI lies in one
 * direction or the other.
 */
export function useCan(minimum: OperatorRole): boolean {
    return atLeast(useOperatorRole(), minimum);
}
